"use strict";

var _defineProperty = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Table = require("./Table.styled");
var _reactVirtualizedAutoSizer = _interopRequireDefault(require("react-virtualized-auto-sizer"));
var _reactWindow = require("react-window");
var _TableHeaderRow = _interopRequireDefault(require("./TableHeaderRow"));
var _TableRow = _interopRequireDefault(require("./TableRow"));
var _objectHash = _interopRequireDefault(require("object-hash"));
var _jsxRuntime = require("react/jsx-runtime");
var getRowData = function getRowData(props) {
  var _props$data$rows$prop;
  return (_props$data$rows$prop = props.data.rows[props.index]) === null || _props$data$rows$prop === void 0 ? void 0 : _props$data$rows$prop.props.data;
};

/**
 * This will render a row
 *
 * @param index The index row to show
 * @param style The style coming from the virtualization
 * @returns {JSX.Element} The Row Element
 */
var Row = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var index = _ref.index,
    style = _ref.style,
    data = _ref.data;
  var rows = data.rows,
    setRowHeight = data.setRowHeight;
  var rowRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (rowRef.current) {
      setRowHeight(index, rowRef.current.clientHeight);
    }
  }, [index, rowRef, setRowHeight]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Table.VirtualizedRow, {
    style: _objectSpread({}, style),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      ref: rowRef,
      children: rows[index]
    })
  });
}, function (prevProps, nextProps) {
  var prevData = getRowData(prevProps);
  var nextData = getRowData(nextProps);
  if (prevData && nextData) {
    return (0, _objectHash.default)(prevData) === (0, _objectHash.default)(nextData) && (0, _objectHash.default)(prevProps.style) === (0, _objectHash.default)(nextProps.style);
  } else {
    return (0, _reactWindow.areEqual)(prevProps, nextProps);
  }
});
var VirtualizedTable = function VirtualizedTable(_ref2) {
  var children = _ref2.children;
  var listRef = (0, _react.useRef)();
  var rows = (0, _react.useMemo)(function () {
    return _react.default.Children.toArray(children);
  }, [children]);

  // eslint-disable-next-line no-unused-vars
  var headerRows = (0, _react.useMemo)(function () {
    return rows.filter(function (row) {
      return row.type === _TableHeaderRow.default;
    });
  }, [rows]);
  // eslint-disable-next-line no-unused-vars
  var tableRows = (0, _react.useMemo)(function () {
    return rows.filter(function (row) {
      return row.type === _TableRow.default;
    });
  }, [rows]);

  /**
   * This is used to store the row height for dynamic sizing
   * @type {React.MutableRefObject<{}>}
   */
  var rowHeights = (0, _react.useRef)({});

  /**
   * This method return the height of a specific row by index.
   *
   * If it isn't found, it used the size 50px, and it will also
   * add the gap size, if defined in the styling.
   *
   * @param index The index of the row
   * @returns {*} The height
   */
  var getRowHeight = (0, _react.useCallback)(function (index) {
    var _rows$index;
    var height = rowHeights.current[index] || 50;
    if (((_rows$index = rows[index]) === null || _rows$index === void 0 ? void 0 : _rows$index.type) === _TableHeaderRow.default) {
      return height;
    } else {
      return height + parseInt(_Table.Gap, 10);
    }
  }, [rows]);

  /**
   * This method will set a height for a specific row.
   *
   * It stores the height in the rowHeights varible,
   * and ask the List to recalculate the heights.
   *
   * @param index The index of the row
   * @param size The height of the row.
   */
  var setRowHeight = (0, _react.useCallback)(function (_ref3) {
    var index = _ref3.index,
      size = _ref3.size;
    listRef.current.resetAfterIndex(0);
    rowHeights.current = _objectSpread({}, rowHeights.current, _defineProperty({}, index, size));
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Table.TableWrapper, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Table.VirtualizedTableWrapper, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactVirtualizedAutoSizer.default, {
        children: function children(_ref4) {
          var height = _ref4.height,
            width = _ref4.width;
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactWindow.VariableSizeList, {
            height: height,
            itemCount: rows.length,
            width: width,
            itemSize: getRowHeight,
            itemData: {
              rows: rows,
              setRowHeight: setRowHeight
            },
            ref: listRef,
            children: Row
          });
        }
      })
    })
  });
};
VirtualizedTable.defaultProps = {};
var _default = exports.default = VirtualizedTable;